import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/site";

export const PartnerStrip = () => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/partners`)
      .then(({ data }) => setPartners(data.filter((p) => p.logo_url)))
      .catch(() => setPartners([]));
  }, []);

  if (partners.length === 0) return null;

  const repeats = partners.length < 8 ? 4 : 2;
  const loop = Array.from({ length: repeats }, () => partners).flat();

  return (
    <section data-testid="partner-strip" className="overflow-hidden border-y border-[#0B3C5C]/10 bg-[#EFF7F1] py-10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="font-mono-x text-center text-xs font-semibold uppercase tracking-[0.3em] text-[#4C8F2F]">
          Insurance & TPA Network
        </p>
      </div>
      <div className="mt-7 overflow-hidden">
        <div
          className="animate-marquee flex w-max items-center gap-5 pr-5"
          style={{ animationDuration: `${Math.max(loop.length * 1.8, 12)}s` }}
        >
          {loop.map((p, i) => (
            <span
              key={`${p.id}-${i}`}
              data-testid={i < partners.length ? `partner-logo-${p.id}` : undefined}
              title={p.name}
              className="flex h-16 shrink-0 items-center justify-center rounded-xl border border-[#0B3C5C]/10 bg-white px-6 shadow-sm transition-shadow duration-300 hover:shadow-md"
            >
              <img src={p.logo_url} alt={p.name} className="max-h-10 max-w-[170px] object-contain" />
            </span>
          ))}
        </div>
      </div>
      <p className="mt-7 px-4 text-center text-xs text-[#4A6B82]">
        Network listing as per respective insurer / TPA terms and processes.
      </p>
    </section>
  );
};
